import React, { useEffect, useState } from "react";
import baseUrl from "../../../../api/baseUrl";
import OHGTd from "./OHGTd";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import EditIcon from "@mui/icons-material/Edit";
import SaveIcon from "@mui/icons-material/Save";

function OpeningHG({ timeData, weekArray }: any) {
  const [dentalActiveDays, setdentalActiveDays] = useState([]);
  const [edit, setedit] = useState(false);

  useEffect(() => {
    baseUrl
      .get("/managetime/getHourGeneral")
      .then((response) => {
        setdentalActiveDays(response.data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  const handleGeneralHours = (e: any) => {
    baseUrl
      .post("/managetime/openHourGeneral", e)
      .then((response) => {})
      .catch((error) => {
        console.log(error);
      });
  };

  const onEdit = () => {
    if (edit) {
      window.location.reload();
    } else {
      setedit(!edit);
    }
  };

  return (
    <div className="w-full bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden sm:mx-auto sm:max-w-6xl">
      <div className="px-4 py-3 border-b border-slate-200 flex items-center justify-between">
        <div className="flex items-center gap-2">
          <div className="w-8 h-8 bg-gradient-to-br from-emerald-500 to-teal-600 rounded-lg flex items-center justify-center">
            <AccessTimeIcon className="text-white" sx={{ fontSize: 20 }} />
          </div>
          <h3 className="text-sm font-semibold text-slate-800">
            Opening Hours (General)
          </h3>
        </div>
        <button
          onClick={() => onEdit()}
          className={`flex items-center gap-1.5 px-3 py-1.5 rounded-md text-xs font-semibold transition-colors ${
            edit
              ? "bg-emerald-500 text-white hover:bg-emerald-600"
              : "bg-slate-100 text-slate-600 hover:bg-slate-200"
          }`}
        >
          {edit ? <SaveIcon sx={{ fontSize: 18 }} /> : <EditIcon sx={{ fontSize: 18 }} />}
          {edit ? "Save" : "Edit"}
        </button>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full text-center">
          <thead>
            <tr className="bg-slate-50/80">
              <th className="px-2 py-2 text-center text-xs font-semibold text-slate-500 uppercase tracking-wider min-w-[72px]">
                Time
              </th>
              {weekArray?.map((item: any, i: number) => (
                <th
                  key={i}
                  className="px-2 py-2 text-center text-xs font-semibold text-slate-500 uppercase tracking-wider"
                >
                  {window.innerWidth > 500 ? item?.week : item?.abbreviation}
                </th>
              ))}
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-100">
            {timeData?.map((time: any, index: number) => (
              <tr key={index} className="hover:bg-slate-50/50">
                <td className="px-2 py-1.5 text-sm font-medium text-slate-600 whitespace-nowrap">
                  {time?.formattedTime}
                </td>
                {weekArray?.map((day: any, idx: number) => (
                  <OHGTd
                    edit={edit}
                    key={idx}
                    dataHeader={{
                      day: day?.week,
                      startTime: time?.startTime,
                      endTime: time?.endTime,
                      interval: time?.interval,
                    }}
                    onClick={(e: any) => handleGeneralHours(e)}
                    activeTime={
                      dentalActiveDays?.filter(
                        (item: any) =>
                          item?.day === day?.week &&
                          item?.startTime === time?.startTime &&
                          item?.endTime === time?.endTime
                      ).length === 1
                    }
                  />
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default OpeningHG;
